import './style.scss';

import './Blocks/Carousel/view/index';

console.log(`[gridible] front.js loaded`);
